var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4004 1.2V5C13.4004 5.88366 14.1167 6.6 15.0004 6.6H18.8V16.8H12.8798C13.5885 15.7056 14 14.4009 14 13C14 9.13401 10.866 6 7 6C6.37769 6 5.77435 6.08121 5.2 6.2336V1.2H13.4004ZM19 18H11.899C10.6364 19.2372 8.90731 20 7 20C3.13401 20 0 16.866 0 13C0 10.2076 1.63505 7.7971 4 6.67363V1C4 0.447716 4.44772 0 5 0H14.5858C14.851 0 15.1054 0.105357 15.2929 0.292893L19.7071 4.70711C19.8946 4.89464 20 5.149 20 5.41421V17C20 17.5523 19.5523 18 19 18ZM14.6004 1.29745V5C14.6004 5.22091 14.7795 5.4 15.0004 5.4H18.7029L14.6004 1.29745ZM7 18.8C10.2033 18.8 12.8 16.2033 12.8 13C12.8 9.79675 10.2033 7.2 7 7.2C3.79675 7.2 1.2 9.79675 1.2 13C1.2 16.2033 3.79675 18.8 7 18.8ZM3 13.6004L8.55142 13.6004L6.57617 15.5757L7.42469 16.4242L10.849 12.9999L7.42469 9.57568L6.57617 10.4242L8.55238 12.4004L3.00001 12.4004L3 13.6004Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.05d904f21cdb7991422bf7793b5a0e8f.svg";
export { ForwardRef as ReactComponent };